import { CustomModal } from 'components/molecules/Modal/Modal'
import { FC } from 'react'
import { useSpecialRequestInfoModalLogic } from './SpecialRequestInfoModal.logic'
import { TSpecialRequestInfoModalProps } from './SpecialRequestInfoModal.types'
import { Typography } from '@mui/material'
import { formatUSPhoneNumberForDisplay } from 'common/utils'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import SmsIcon from '@mui/icons-material/Sms'
import EmailIcon from '@mui/icons-material/Email'
import './SpecialRequestInfoModal.scss'
import AddIcon from '@mui/icons-material/Add'

export const SpecialRequestInfoModal: FC<TSpecialRequestInfoModalProps> = (
  props
) => {
  const { onClose, onHeaderButtonAction, surgeryId, showModal, canAdd } = props

  const logic = useSpecialRequestInfoModalLogic(props)

  return (
    <CustomModal
      open={showModal}
      closeButtonOnly
      isLoadingState={false}
      header="Special Request"
      primaryButtonText="Create"
      secondaryButtonAction={onClose}
      headerButtonIcon={canAdd ? <AddIcon color="primary" /> : undefined}
      headerButtonAction={() => onHeaderButtonAction(surgeryId)}
    >
      <div className="special-request-info-modal-container">
        {logic.specialRequests.map(
          ({
            _id: id,
            instruments,
            instrumentsNotes,
            salesReps,
            createdAt,
          }) => (
            <div key={id} className="special-request-wrapper">
              {instruments?.length > 0 && (
                <div className="instruments-container">
                  <Typography variant="h3">Instruments</Typography>
                  <div className="instruments-wrapper">
                    <Typography
                      key={id}
                      variant="body1"
                      className="instruments"
                    >
                      {instruments.join(', ')}
                    </Typography>
                    {instrumentsNotes?.length > 0 && (
                      <div className="notes-container">
                        <Typography variant="body1" className="notes-title">
                          Notes:
                        </Typography>
                        <ul>
                          {instrumentsNotes.map((instrumentNote) => (
                            <li>
                              <Typography variant="body1">
                                {instrumentNote}
                              </Typography>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {salesReps?.length > 0 && (
                <div className="sales-reps-container">
                  <Typography variant="h3">Sales Reps</Typography>
                  <div className="sales-reps">
                    {salesReps.map(
                      ({
                        firstName,
                        lastName,
                        email,
                        phoneNumber,
                        notifyEmail,
                        notifySms,
                        invitationAccepted,
                        companyName,
                      }) => (
                        <div className="sales-rep">
                          <Typography variant="body2" className="name">
                            {lastName}, {firstName}
                          </Typography>
                          <Typography variant="body2">{companyName}</Typography>
                          <div className="email-info">
                            <Typography variant="body2">{email}</Typography>
                            <Typography variant="body2">
                              {formatUSPhoneNumberForDisplay(phoneNumber)}
                            </Typography>
                          </div>
                          <div className="notifications-wrapper">
                            <div className="notification">
                              <EmailIcon
                                fontSize="small"
                                color={notifyEmail ? 'success' : 'error'}
                              />
                              {notifyEmail ? (
                                <CheckCircleRoundedIcon
                                  fontSize="small"
                                  color="success"
                                />
                              ) : (
                                <CancelRoundedIcon
                                  fontSize="small"
                                  color="error"
                                />
                              )}
                            </div>
                            <div className="notification">
                              <SmsIcon
                                fontSize="small"
                                color={notifySms ? 'success' : 'error'}
                              />
                              {notifySms ? (
                                <CheckCircleRoundedIcon
                                  fontSize="small"
                                  color="success"
                                />
                              ) : (
                                <CancelRoundedIcon
                                  fontSize="small"
                                  color="error"
                                />
                              )}
                            </div>
                            {(notifyEmail || notifySms) && (
                              <div className="notification">
                                <Typography
                                  variant="body2"
                                  className="bold"
                                  color={
                                    invitationAccepted
                                      ? 'var(--success)'
                                      : 'var(--error)'
                                  }
                                >
                                  {invitationAccepted === true
                                    ? 'CONFIRMED'
                                    : invitationAccepted === false
                                    ? 'DECLINED'
                                    : 'PENDING REP CONFIRMATION'}
                                </Typography>
                                {invitationAccepted ? (
                                  <CheckCircleRoundedIcon
                                    fontSize="small"
                                    color="success"
                                  />
                                ) : (
                                  <CancelRoundedIcon
                                    fontSize="small"
                                    color="error"
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
              <Typography variant="body2" className="date">
                {new Date(createdAt).toLocaleString('en-US', {
                  dateStyle: 'short',
                  timeStyle: 'short',
                })}
              </Typography>
            </div>
          )
        )}
      </div>
    </CustomModal>
  )
}
